import React from 'react';

const AdvertiserRole = ({
  updateProfile,
  profileData,
  setRole,
  localisations,
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    setRole(value);
    updateProfile(name, value);
  };

  return (
    <fieldset className="form-group form-group--no-validation form-group--advertiser-role">
      <legend className="form-group__title form-group__title--light">
        I am a
      </legend>
      <span className="form-group__radio">
        <input
          name="advertiser_role"
          type="radio"
          value="live in landlord"
          id="liveInLandlord"
          onChange={handleChange}
          checked={profileData?.advertiser_role === 'live in landlord'}
        ></input>
        <label htmlFor="liveInLandlord">
          {localisations.live_in_landlord || 'Live in landlord'}
          <span className="form-group__advertiser-role-text">
            (I own the property and live there)
          </span>
        </label>
      </span>
      <span className="form-group__radio">
        <input
          name="advertiser_role"
          type="radio"
          value="live out landlord"
          id="liveOutLandlord"
          onChange={handleChange}
          checked={profileData?.advertiser_role === 'live out landlord'}
        ></input>
        <label htmlFor="liveOutLandlord">
          Live out landlord
          <span className="form-group__advertiser-role-text">
            (I own the property but don&apos;t live there)
          </span>
        </label>
      </span>
      <span className="form-group__radio">
        <input
          name="advertiser_role"
          type="radio"
          id="currentTenant"
          value="current flatmate"
          onChange={handleChange}
          checked={profileData?.advertiser_role === 'current flatmate'}
        ></input>
        <label htmlFor="currentTenant">
          Current tenant/{localisations.flatmate || 'flatmate'}
          <span className="form-group__advertiser-role-text">
            (I am living in the property)
          </span>
        </label>
      </span>
      <span className="form-group__radio">
        <input
          name="advertiser_role"
          type="radio"
          id="agent"
          value="agent"
          onChange={handleChange}
          checked={profileData?.advertiser_role === 'agent'}
        ></input>
        <label htmlFor="agent">
          {localisations.agent || 'Agent'}
          <span className="form-group__advertiser-role-text">
            (I am advertising on a landlord&apos;s behalf)
          </span>
        </label>
      </span>
      <span className="form-group__radio">
        <input
          name="advertiser_role"
          type="radio"
          id="formerFlatmate"
          value="former flatmate"
          onChange={handleChange}
          checked={profileData?.advertiser_role === 'former flatmate'}
        ></input>
        <label htmlFor="formerFlatmate">
          Former {localisations.flatmate || 'flatmate'}
          <span className="form-group__advertiser-role-text">
            (I am moving out and need someone to replace me)
          </span>
        </label>
      </span>
    </fieldset>
  );
};

export default AdvertiserRole;
